// Care page FAQ: category tabs + single-open accordion per tab.
// Ported from old-maperce-theme's faq-tabs.js. Tab buttons are moved out of their
// (display:contents) wrapper into one shared nav row, matching old theme's own DOM technique.
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-vc-care-faq]');

  sections.forEach((section) => {
    const wrapper = section.querySelector('.vc-care-faq__wrapper');
    if (!wrapper) return;

    const navigation = document.createElement('div');
    navigation.className = 'vc-care-faq__nav';

    const tabButtons = wrapper.querySelectorAll('[data-vc-faq-tab-button]');
    const tabContents = wrapper.querySelectorAll('[data-vc-faq-tab-content]');

    tabButtons.forEach((button) => navigation.appendChild(button));
    wrapper.parentNode.insertBefore(navigation, wrapper);

    if (tabButtons.length > 0) {
      tabButtons[0].classList.add('is-active');
      tabContents[0].classList.add('is-active');

      const firstFaq = tabContents[0].querySelector('[data-vc-faq-item]');
      if (firstFaq) {
        firstFaq.classList.add('is-active');
        firstFaq.querySelector('[data-vc-faq-question]').setAttribute('aria-expanded', 'true');
      }
    }

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function () {
        tabButtons.forEach((btn) => btn.classList.remove('is-active'));
        tabContents.forEach((content) => content.classList.remove('is-active'));

        this.classList.add('is-active');
        tabContents[index].classList.add('is-active');

        const faqItems = tabContents[index].querySelectorAll('[data-vc-faq-item]');
        faqItems.forEach((item) => {
          item.classList.remove('is-active');
          item.querySelector('[data-vc-faq-question]').setAttribute('aria-expanded', 'false');
        });

        const firstFaq = tabContents[index].querySelector('[data-vc-faq-item]');
        if (firstFaq) {
          firstFaq.classList.add('is-active');
          firstFaq.querySelector('[data-vc-faq-question]').setAttribute('aria-expanded', 'true');
        }
      });
    });

    const allFaqItems = section.querySelectorAll('[data-vc-faq-item]');
    allFaqItems.forEach((item) => {
      const question = item.querySelector('[data-vc-faq-question]');

      question.addEventListener('click', function () {
        const parentTab = item.closest('[data-vc-faq-tab-content]');
        const isActive = item.classList.contains('is-active');

        const siblingItems = parentTab.querySelectorAll('[data-vc-faq-item]');
        siblingItems.forEach((otherItem) => {
          otherItem.classList.remove('is-active');
          otherItem.querySelector('[data-vc-faq-question]').setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
          item.classList.add('is-active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});
